import React from 'react';
import DEFINE, { PATHS } from './../constants/Define';

export default [
    {
        title: "dashboard",
        group: "dashboard",
        path: '/',
        exact: true,
        icon: 'dashboard',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.HOME,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW]
        // main : () => <Layout.Index />
    }, {
        title: "users",
        group: "users",
        path: '/users/list',
        exact: false,
        icon: 'user',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.USER,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
        children: [
            {
                title: "createUsers",
                group: "users",
                path: '/users/action',
                exact: false,
                icon: 'user',
                show: false,
            }, {
                title: "updateUsers",
                group: "users",
                path: '/users/action/:id',
                exact: false,
                icon: 'user',
                show: false,
            }
        ]
    }, {
        title: "roles",
        group: "roles",
        path: '/roles/list',
        exact: false,
        icon: 'apartment',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.ROLE,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
        children: [
            {
                title: "createRoles",
                group: "roles",
                path: '/roles/action',
                exact: false,
                icon: 'apartment',
                show: false,
            }, {
                title: "updateRoles",
                group: "roles",
                path: '/roles/action/:id',
                exact: false,
                icon: 'apartment',
                show: false,
            }
        ]
    }, {
        title: "banners",
        group: "banners",
        path: '/banners/list',
        exact: false,
        icon: 'picture',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.BANNER,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
        children: [
            {
                title: "createBanners",
                group: "banners",
                path: '/banners/action',
                exact: false,
                icon: 'user',
                show: false,
            }, {
                title: "updateBanners",
                group: "banners",
                path: '/banners/action/:id',
                exact: false,
                icon: 'user',
                show: false,
            }
        ]
    }, {
        title: "orders",
        group: "orders",
        path: '/orders/list',
        exact: false,
        icon: 'snippets',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.ORDER,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.SALE_ORDER, DEFINE.GENERAL.PERMISSION.RESEND_EMAIL, DEFINE.GENERAL.PERMISSION.EXPORT_VOUCHER],
        children: [
            {
                title: "orderDetail",
                group: "orders",
                path: '/orders/:id',
                exact: false,
                icon: 'user',
                show: false,
            }
        ]
    }, {
        title: "customerServices",
        tagSub: "tickets",
        exact: false,
        path: 'tickets',
        show: true,
        icon: "faHeadset",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET_MANAGEMENT,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        developing: process.env.REACT_APP_ENVIRONMENT !== 'production',
        children: [
            {
                title: "tickets",
                group: "tickets",
                path: PATHS.TICKET.LIST.path,
                tagSub: "tickets",
                exact: false,
                icon: 'faTicketAlt',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
                children: [
                    {
                        title: "updateTickets",
                        group: "tickets",
                        tagSub: "tickets",
                        path: PATHS.TICKET.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "myTickets",
                group: "myTickets",
                path: PATHS.TICKET.MY_TICKET.path,
                tagSub: "tickets",
                exact: false,
                icon: 'faColumns',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.MY_TICKET,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
            },
            {
                title: "ticketAssignConfigs",
                group: "ticketAssignConfigs",
                path: PATHS.TICKET_ASSIGN_CONFIG.LIST.path,
                tagSub: "tickets",
                exact: false,
                icon: 'faCalendarWeek',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET_ASSIGN_CONFIG,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createTicketAssignConfigs",
                        group: "ticketAssignConfigs",
                        tagSub: "tickets",
                        path: PATHS.TICKET_ASSIGN_CONFIG.CREATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    },
                    {
                        title: "updateTicketAssignConfigs",
                        group: "ticketAssignConfigs",
                        tagSub: "tickets",
                        path: PATHS.TICKET_ASSIGN_CONFIG.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
        ]
    }, {
        title: "tours",
        tagSub: "tours",
        exact: false,
        path: 'tours',
        show: true,
        icon: "faSuitcaseRolling",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.TOUR_MANAGEMENT,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "warehousemanagement",
                group: "warehousemanagement",
                path: PATHS.WAREHOUSEMANAGEMENT.LIST.path,
                tagSub: "warehousemanagement",
                exac: false,
                icon: "container",
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.WAREHOUSEMANAGEMENT,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE],
                children: [
                    {
                        title: "createWarehousemanagement",
                        group: "warehousemanagement",
                        tagSub: "warehousemanagement",
                        path: PATHS.WAREHOUSEMANAGEMENT.CREATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, 
                    {
                        title: "updateWarehousemanagement",
                        group: "warehousemanagement",
                        path: PATHS.WAREHOUSEMANAGEMENT.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    },
                ]
            },
            {
                title: "tours",
                group: "tours",
                path: PATHS.TOUR.LIST.path,
                tagSub: "tours",
                exact: false,
                icon: 'faSuitcaseRolling',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.TOUR,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createTours",
                        group: "tours",
                        path: PATHS.TOUR.CREATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateTours",
                        group: "tours",
                        path: PATHS.TOUR.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "suppliers",
                group: "suppliers",
                path: PATHS.SUPPLIER.LIST.path,
                tagSub: "tours",
                exact: false,
                icon: 'faTruck',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.SUPPLIER,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createSuppliers",
                        group: "suppliers",
                        path: PATHS.SUPPLIER.CREATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateSuppliers",
                        group: "suppliers",
                        path: PATHS.SUPPLIER.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "supplierproducts",
                group: "suppliers",
                path: PATHS.SUPPLIER_PRODUCT.LIST.path,
                tagSub: "tours",
                exact: false,
                icon: 'shop',
                show: false,
                routeName: DEFINE.GENERAL.ROUTE_NAME.SUPPLIER_PRODUCT,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: []
            }
        ]
    }, {
        title: "vouchers",
        tagSub: "vouchers",
        exact: false,
        path: 'vouchers',
        show: true,
        icon: "tag",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER_MANAGEMENT,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "groups",
                group: "groups",
                tagSub: "vouchers",
                path: '/groups/list',
                exact: false,
                icon: 'tags',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.GROUP,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createGroups",
                        group: "groups",
                        tagSub: "vouchers",
                        path: '/groups/action',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateGroups",
                        group: "groups",
                        tagSub: "vouchers",
                        path: '/groups/action/:id',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "groupCategories",
                group: "groupCategories",
                tagSub: "vouchers",
                path: PATHS.GROUP_CATEGORY.LIST.path,
                exact: false,
                icon: 'faTags',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.GROUP_CATEGORY,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createGroupCategories",
                        group: "groupCategories",
                        tagSub: "vouchers",
                        path: PATHS.GROUP_CATEGORY.CREATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateGroupCategories",
                        group: "groupCategories",
                        tagSub: "vouchers",
                        path: PATHS.GROUP_CATEGORY.DETAIL.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    },
                    {
                        title: "translateGroupCategories",
                        group: "groupCategories",
                        tagSub: "vouchers",
                        path: PATHS.GROUP_CATEGORY.DETAIL.TRANSLATE.path,
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "vouchers",
                group: "vouchers",
                tagSub: "vouchers",
                path: '/vouchers/list',
                exact: false,
                icon: 'tag',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE],
                children: [
                    {
                        title: "createVouchers",
                        group: "vouchers",
                        tagSub: "vouchers",
                        path: '/vouchers/action',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateVouchers",
                        group: "vouchers",
                        tagSub: "vouchers",
                        path: '/vouchers/action/:id',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "importVouchers",
                        group: "vouchers",
                        tagSub: "vouchers",
                        path: '/vouchers/import',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "checkVoucher",
                group: "checkVoucher",
                tagSub: "vouchers",
                path: '/vouchers/check',
                exact: false,
                icon: 'check',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.CHECK_VOUCHER,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.USE_VOUCHER],
            },
            {
                title: "products",
                group: "products",
                tagSub: "vouchers",
                path: '/products/list',
                exact: false,
                icon: 'shop',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.PRODUCT,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createProducts",
                        group: "products",
                        tagSub: "vouchers",
                        path: '/products/action',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateProducts",
                        group: "products",
                        tagSub: "vouchers",
                        path: '/products/action/:id',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
            {
                title: "properties",
                group: "properties",
                tagSub: "vouchers",
                path: '/properties/list',
                exact: false,
                icon: 'environment',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.PROPERTY,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createProperties",
                        group: "properties",
                        tagSub: "vouchers",
                        path: '/properties/action',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }, {
                        title: "updateProperties",
                        group: "properties",
                        tagSub: "vouchers",
                        path: '/properties/action/:id',
                        exact: false,
                        icon: 'user',
                        show: false,
                    }
                ]
            },
        ]
    }, {
        title: "hotels",
        tagSub: "hotels",
        exact: false,
        path: 'hotels',
        show: true, // process.env.REACT_APP_ENVIRONMENT !== 'production' && process.env.REACT_APP_ENVIRONMENT !== 'staging',
        icon: "faHotel",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.HOTEL_MANAGEMENT,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        // developing: process.env.REACT_APP_ENVIRONMENT !== 'production', // need to remove when done with the layout and permission from api for hotels
        children: [
            {
                title: "hotels",
                group: "hotels",
                tagSub: "hotels",
                path: PATHS.HOTEL.LIST.path,
                exact: false,
                icon: 'faBed',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.HOTEL,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createHotels",
                        group: "hotels",
                        tagSub: "hotels",
                        path: PATHS.HOTEL.CREATE.path,
                        exact: false,
                        icon: 'home',
                        show: false,
                    }, {
                        title: "updateHotels",
                        group: "hotels",
                        tagSub: "hotels",
                        path: PATHS.HOTEL.DETAIL.path,
                        exact: false,
                        icon: 'home',
                        show: false,
                    }
                ]
            }, {
                title: "locations",
                group: "locations",
                tagSub: "hotels",
                path: PATHS.LOCATION.LIST.path,
                exact: false,
                icon: 'environment',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.LOCATION,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createLocations",
                        group: "locations",
                        tagSub: "hotels",
                        path: PATHS.LOCATION.CREATE.path,
                        exact: false,
                        icon: 'environment',
                        show: false,
                    }, {
                        title: "updateLocations",
                        group: "locations",
                        tagSub: "hotels",
                        path: PATHS.LOCATION.DETAIL.path,
                        exact: false,
                        icon: 'environment',
                        show: false,
                    }
                ]
            }, {
                title: "popularPlaces",
                group: "popularPlaces",
                tagSub: "hotels",
                path: PATHS.POPULAR_PLACE.LIST.path,
                exact: false,
                icon: 'compass',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.POPULAR_PLACE,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createPopularPlaces",
                        group: "popularPlaces",
                        tagSub: "hotels",
                        path: PATHS.POPULAR_PLACE.CREATE.path,
                        exact: false,
                        icon: 'compass',
                        show: false,
                    }, {
                        title: "updatePopularPlaces",
                        group: "popularPlaces",
                        tagSub: "hotels",
                        path: PATHS.POPULAR_PLACE.DETAIL.path,
                        exact: false,
                        icon: 'compass',
                        show: false,
                    }
                ]
            }, {
                title: "customPrices",
                group: "customPrices",
                tagSub: "hotels",
                path: PATHS.CUSTOM_PRICE.LIST.path,
                exact: false,
                icon: 'dollar',
                show: false,
                routeName: DEFINE.GENERAL.ROUTE_NAME.CUSTOM_PRICE,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createCustomPrices",
                        group: "customPrices",
                        tagSub: "hotels",
                        path: PATHS.CUSTOM_PRICE.CREATE.path,
                        exact: false,
                        icon: 'dollar',
                        show: false,
                    }, {
                        title: "updateCustomPrices",
                        group: "customPrices",
                        tagSub: "hotels",
                        path: PATHS.CUSTOM_PRICE.DETAIL.path,
                        exact: false,
                        icon: 'dollar',
                        show: false,
                    }
                ]
            }, {
                title: "roomTypes",
                group: "roomTypes",
                tagSub: "hotels",
                path: PATHS.ROOM_TYPE.LIST.path,
                exact: false,
                icon: "home",
                show: false,
                routeName: DEFINE.GENERAL.ROUTE_NAME.ROOM_TYPE,
                permissions: [
                    DEFINE.GENERAL.PERMISSION.VIEW,
                    DEFINE.GENERAL.PERMISSION.CREATE,
                    DEFINE.GENERAL.PERMISSION.UPDATE,
                    DEFINE.GENERAL.PERMISSION.DELETE
                ],
                children: [
                    {
                        title: "createRoomTypes",
                        group: "roomTypes",
                        tagSub: "hotels",
                        path: PATHS.ROOM_TYPE.CREATE.path,
                        exact: false,
                        icon: "home",
                        show: false
                    },
                    {
                        title: "updateRoomTypes",
                        group: "roomTypes",
                        tagSub: "hotels",
                        path: PATHS.ROOM_TYPE.DETAIL.path,
                        exact: false,
                        icon: "home",
                        show: false
                    }
                ]
            },
        ],
    },{
        title: "pointchangehistory",
        group: "pointchangehistory",
        path: PATHS.POINT_CHANGE_HISTORY.LIST.path,
        tagSub: "pointchangehistory",
        exac: false,
        icon: "container",
        show: true,
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.POINT_CHANGE_HISTORY,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
    }, {
        title: "vinpearlGolf",
        tagSub: "vinpearlGolf",
        exact: false,
        path: PATHS.GOLF_COURSE.path,
        show: true,
        icon: "golf_course",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.VINPEARL_GOLF,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "golfCourse",
                group: "golfCourse",
                tagSub: "vinpearlGolf",
                path: PATHS.GOLF_COURSE.LIST.path,
                exact: false,
                icon: "golf_course",
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.GOLF_COURSE,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CONFIRM, DEFINE.GENERAL.PERMISSION.CANCEL],
                children: [
                    {
                        title: "createGolfCourse",
                        group: "golfCourse",
                        tagSub: "vinpearlGolf",
                        path: PATHS.GOLF_COURSE.CREATE.path,
                        exact: false,
                        icon: 'home',
                        show: false,
                    }, {
                        title: "updateGolfCourse",
                        group: "golfCourse",
                        tagSub: "vinpearlGolf",
                        path: PATHS.GOLF_COURSE.DETAIL.path,
                        exact: false,
                        icon: 'home',
                        show: false,
                    }
                ]
            }
        ]
    }, {
        title: "contents",
        tagSub: "contents",
        exact: false,
        path: 'contents',
        show: true,
        icon: "home",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.WEBSITE,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "categories",
                group: "categories",
                tagSub: "contents",
                path: PATHS.CATEGORY.LIST.path,
                exact: false,
                icon: 'align-left',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.CATEGORY,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createCategories",
                        group: "categories",
                        tagSub: "contents",
                        path: PATHS.CATEGORY.CREATE.path,
                        exact: false,
                        icon: 'align-left',
                        show: false,
                    }, {
                        title: "updateCategories",
                        group: "categories",
                        tagSub: "contents",
                        path: PATHS.CATEGORY.DETAIL.path,
                        exact: false,
                        icon: 'align-left',
                        show: false,
                    }
                ]
            }, {
                title: "pages",
                group: "pages",
                tagSub: "contents",
                path: PATHS.PAGE.LIST.path,
                exact: false,
                icon: 'copy',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.PAGE,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createPages",
                        group: "pages",
                        tagSub: "contents",
                        path: PATHS.PAGE.CREATE.path,
                        exact: false,
                        icon: 'copy',
                        show: false,
                    }, {
                        title: "updatePages",
                        group: "pages",
                        tagSub: "contents",
                        path: PATHS.PAGE.DETAIL.path,
                        exact: false,
                        icon: 'copy',
                        show: false,
                    }
                ]
            }, {
                title: "posts",
                group: "posts",
                tagSub: "contents",
                path: PATHS.POST.LIST.path,
                exact: false,
                icon: 'edit',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.POST,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "createPosts",
                        group: "posts",
                        tagSub: "contents",
                        path: PATHS.POST.CREATE.path,
                        exact: false,
                        icon: 'edit',
                        show: false,
                    }, {
                        title: "updatePosts",
                        group: "posts",
                        tagSub: "contents",
                        path: PATHS.POST.DETAIL.path,
                        exact: false,
                        icon: 'edit',
                        show: false,
                    }
                ]
            }, {
                title: "ratings",
                group: "ratings",
                tagSub: "contents",
                path: PATHS.RATING.LIST.path,
                exact: false,
                icon: 'star',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.RATING,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.APPROVE, DEFINE.GENERAL.PERMISSION.DELETE],
                children: [
                    {
                        title: "detailRatings",
                        group: "ratings",
                        tagSub: "contents",
                        path: PATHS.RATING.DETAIL.path,
                        exact: false,
                        icon: 'edit',
                        show: false,
                    }
                ]
            }
        ],
    }, {
        title: 'priceMakeup',
        tagSub: "priceMakeup",
        exact: false,
        path: 'priceMakeup',
        show: true,
        icon: "faMoneyCheckAlt",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.PRICE_MAKEUP,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "priceMakeupFlight",
                group: "priceMakeupFlight",
                tagSub: "priceMakeup",
                path: PATHS.PRICE_MAKEUP.FLIGHT.path,
                exact: false,
                icon: 'faPlane',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.FLIGHT_PRICE_CONFIG,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
            },
        ],
    }, {
        title: 'reports',
        tagSub: "reports",
        exact: false,
        path: 'reports',
        show: true,
        icon: "container",
        isParrentMenu: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.REPORT,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
        children: [
            {
                title: "saleReports",
                group: "saleReports",
                tagSub: "reports",
                path: PATHS.REPORT.SALE_REPORT.path,
                exact: false,
                icon: 'faMoneyCheckAlt',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.SALE_REPORT,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
            },
            {
                title: "redemptionReports",
                group: "redemptionReports",
                tagSub: "reports",
                path: PATHS.REPORT.VOUCHER_REDEEMTION_REPORT.path,
                exact: false,
                icon: 'faTag',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER_REDEEMTION_REPORT,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
            },
        ],
    }, {
        title: "403",
        group: "403",
        path: '/403',
        exact: true,
        icon: 'dashboard',
        show: false,
        // main : () => <Layout.Index />
    }, {
        title: "profile",
        group: "profile",
        path: PATHS.PROFILE.path,
        exact: true,
        icon: 'dashboard',
        show: false,
        // main : () => <Layout.Index />
    },
     {
        title: "fnb",
        group: "fnb",
        path: '/fnb',
        exact: false,
        icon: 'shop',
        show: true,
        routeName: DEFINE.GENERAL.ROUTE_NAME.FNB,
        permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE], 
        children: [
            {
                title: "outlets",
                group: "fnbOutlets",
                tagSub: "fnb",
                path: '/fnb/outlets',
                exact: true,
                icon: 'shop',
                show: true,
                routeName: DEFINE.GENERAL.ROUTE_NAME.FNB_OUTLET,
                permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.SYNC],
            },
            {
                title: "outletDetail",
                group: "fnbOutlets",
                tagSub: "fnb",
                path: '/fnb/outlet/:id',
                exact: false,
                icon: 'shop',
                show: false,
            },
            {
                title: "menuManager",
                group: "fnbMenus",
                tagSub: "fnb",
                path: '/fnb/outlet/:id/menus',
                exact: false,
                icon: 'shop',
                show: false,
            }
        ]
    },
];

// export default routes;
